import {SET_DIVISION, setDivisionT} from "../reducers/DivisionState";


export const SetDivision = (data: setDivisionT['data']) => {
    return({
        type: SET_DIVISION,
        data: data
    })
}
